<template src="./navbar.html" />

<script>
import { WebSocketService } from '../../services/WebSocketService';

export default {
  name: 'Navbar',
  props: {
    showLogo: { type: Boolean, default: true },
    fluid: { type: Boolean, default: false },
    containerType: { type: String, default: 'container' },
  },
  data() {
    return {
      company: this.$company,
      portal: this.$portal,
      user: this.$user,
      dev: this.$dev,
      notifications: this.$notifications,
      localPaymentUrl: 'http://localhost:8063/mf/payment/',
    };
  },
  mounted() {
    this.$user.hasAccountsModuleAccess();
  },
  computed: {
    visible() {
      if (
        this.$route.name != 'Login'
        && this.$route.name != 'ChangePassword'
        && this.$route.name != 'Register'
        && this.$route.name != 'Dashboard'
        && this.$route.name != 'Menu'
        && this.$route.name != 'SingleScript'
        && !this.$route.name.includes('Module')
      )
        return false;
      return true;
    },
    hasItems() {
      if (!_.isEmpty(_.get(this.company.json, 'phone')) || this.user.isLogged())
        return true;
      return false;
    },

    showHelpButton() {
      return this.company.json.showHelpButton;
    },
    showAccountsButton() {
      return this.user.hasAccountsAccess;
    },
  },
  methods: {
    logout() {
      WebSocketService.closeConnectionFromRecipientAndClientId(
        this.user.json.email,
        window.sessionStorage.getItem('notificationClientId'),
      );
      window.sessionStorage.clear();

      this.notifications.clear();

      this.user.logout();
      this.$router.push('/');
    },
    help() {
      this.$brain.redirectToRoute('/help');
    },
    goToAccounts() {
      window.location.href = this.dev.is === 'DEV' ? this.localPaymentUrl : `${window.location.origin}/mf/payment`;
    },
    openProfile() {
      if (this.$brain.company.json.hasExternalAuth) {
        this.$brain.swal({
          type: 'warning',
          html: `
						<p>Não é possível alterar o perfil!</p>
          `,
        });
        return;
      }
      this.$brain.openProfile();
    },
    openPassword() {
      this.$brain.openPassword();
    },
    openHost() {
      this.$brain.openHost();
    },
  },
};
</script>

<style scoped src="./navbar.scss" lang="scss"></style>
